/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';

import TYPES from './mutation-types';

Vue.use(Vuex);

/* eslint-disable no-param-reassign */

export default new Vuex.Store({
  state: {
    loadingCounter: 0,
    mapId: window.localStorage.getItem('mapId'), // 地图id
    storeId: window.localStorage.getItem('storeId'),
    childStoreId: window.localStorage.getItem('childStoreId'),
    materFlag: window.localStorage.getItem('materFlag'), // 新建地图母地图是否上传
    childFlag: window.localStorage.getItem('childFlag'), // 新建地图子地图是否上传
    mergeFlag: window.localStorage.getItem('mergeFlag'),// 地图合成
    CADUrl: window.localStorage.getItem('CADUrl'),// 地图合成
    alignFlag: window.localStorage.getItem('alignFlag'),//地图对齐
  },
  getters: {
    loading: state => state.loadingCounter > 0,
    mapId: state => state.mapId,
    storeId: state => state.storeId,
    childStoreId: state => state.childStoreId,
    materFlag: state => state.materFlag,
    childFlag: state => state.childFlag,
    mergeFlag: state => state.mergeFlag,
    CADUrl: state => state.CADUrl,
    alignFlag: state => state.alignFlag
  },
  mutations: {
    [TYPES.LOAD_START](state) { state.loadingCounter += 1; },
    [TYPES.LOAD_END](state) { state.loadingCounter -= 1; },
    getMapId(state, id) {
      state.mapId = id;
      window.localStorage.setItem('mapId', id);
    },
    getStoreId(state, id) {
      state.storeId = id;
      window.localStorage.setItem('storeId', id);
    },
    getChildStoreId(state, id) {
      state.childStoreId = id;
      window.localStorage.setItem('childStoreId', id);
    },
    getMaterFlag(state, id) {
      state.materFlag = id;
      window.localStorage.setItem('materFlag', id);
    },
    getChildFlag(state, id) {
      state.childFlag = id;
      window.localStorage.setItem('childFlag', id);
    },
    getMergeFlag(state, id) {
      state.mergeFlag = id;
      window.localStorage.setItem('mergeFlag', id);
    },
    getCADUrl(state, value) {
      state.CADUrl = value;
      window.localStorage.setItem('CADUrl', value);
    },
    getAlign(state, value) {
      state.alignFlag = value;
      window.localStorage.setItem('alignFlag', value);
    }
  },
  actions: {
    [TYPES.LOAD_START]({ commit }) {
      commit(TYPES.LOAD_START);
    },
    [TYPES.LOAD_END]({ commit }) {
      setTimeout(() => { commit(TYPES.LOAD_END); }, 1500);
    }
  }
});
